import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, getChildId } from "./api";
import { loadRecordings, play } from "./audio";

export const GROUPS = [
  { key: "initial", name: "聲母", color: "#C83E2B", soft: "#FDECE8" },
  { key: "medial", name: "介音", color: "#2E7D32", soft: "#E7F4E8" },
  { key: "final", name: "韻母", color: "#1D6FB8", soft: "#E3F0FB" },
];

export const STATUS = {
  mastered: { label: "學會了", color: "#16a34a" },
  learning: { label: "學習中", color: "#f59e0b" },
  needs_practice: { label: "再練練", color: "#dc2626" },
  not_started: { label: "還沒學", color: "#a8a29e" },
};

export const useRoom = () => {
  const childId = getChildId();
  const nav = useNavigate();
  const [cards, setCards] = useState(null);
  const reload = useCallback(() => api.get(`/zhuyin-room?child_id=${childId}`).then(({ data }) => setCards(data)).catch(() => nav("/profiles")), [childId, nav]);
  useEffect(() => {
    if (!childId) return nav("/profiles");
    loadRecordings();
    reload();
  }, [childId, nav, reload]);
  return { cards, childId, reload };
};

export const say = (z) => play(z.audio_text, z.audio_url);

export const markSeen = (childId, symbol) => api.post("/progress/seen", { child_id: childId, items: [{ type: "zhuyin", key: symbol }] }).catch(() => {});

export const recordAttempt = (childId, symbol, kind, correct) =>
  api.post("/zhuyin-room/attempt", { child_id: childId, symbol, kind, correct }).catch(() => {});
